var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ruoli-completati" },
    _vm._l(_vm.ruoli_array, function (ruolo) {
      return _c(
        "span",
        {
          key: ruolo,
          staticClass: "onlyLetter",
          class: _vm.ruoliClasses(ruolo, _vm.id_squadra),
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.acquistiPerRuolo(ruolo, _vm.id_squadra)) +
              "\n  "
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }